import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  const {
    delayRemove
  } = this.state;
  const hide = this.attr("hide");
  const timeout = this.attr("timeout");
  const type = this.attr("type");
  const cta = this.attr("cta");
  const ctaHref = this.attr("cta-href");
  const ctaTarget = this.attr("cta-target");
  const undoable = this.attr("undoable");
  const hideCancelButton = this.attr("hide-cancel-button");
  const ctaElement = cta ? /* @__PURE__ */ jsx("a", { sel: ".mp-toast-action.mp-toast-cta", attrs: ctaHref ? {
    href: ctaHref,
    target: ctaTarget
  } : {}, on: {
    click: this.helpers.ctaClick
  } }, cta) : null;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-toast-stage", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, !hide && /* @__PURE__ */ jsx("div", { sel: ".mp-toast-container", class: {
    // casting to any, since snabbdom-delayed-module uses a non standard way to hook into snabbdom
    // TODO: modify VNode class definition in Panel to include snabbdom-delayed-module classes
    delayed: {
      "mp-toast-in": true
    },
    remove: {
      "mp-toast-out": true,
      delayRemove
    }
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-toast-widget" }, /* @__PURE__ */ jsx("div", { sel: ".icon-container", class: {
    [type]: true,
    timeout
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: this.helpers.getIcon()
  } }), timeout ? /* @__PURE__ */ jsx("div", { sel: ".icon-container-animated-fadeout", class: {
    [type]: true
  }, style: {
    "animation-duration": timeout + "ms"
  } }) : null), /* @__PURE__ */ jsx("div", { sel: ".mp-toast-body" }, /* @__PURE__ */ jsx("div", { sel: ".mp-toast-message" }, /* @__PURE__ */ jsx("slot", null)), /* @__PURE__ */ jsx("div", { sel: ".mp-toast-actions" }, ctaElement, undoable ? /* @__PURE__ */ jsx("div", { sel: ".mp-toast-action.mp-toast-undo", on: {
    click: this.helpers.undoClick
  } }, this.attr("undo-label")) : null), !hideCancelButton ? /* @__PURE__ */ jsx("div", { sel: ".mp-toast-close", on: {
    click: this.helpers.closeClick
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "x"
  } })) : null))));
}
